export default class PickUpTime {
  constructor(timeFrom, timeTo, timeZone, date = null, dayType = null, deadLine = null) {
    this.timeFrom = timeFrom;
    this.timeTo = timeTo;
    this.timeZone = timeZone;
    this.date = date;
    this.dayType = dayType;
    this.deadLine = deadLine;
  }

  get text() {
    const timeFormat = { hour: '2-digit', minute: '2-digit', hour12: false };
    const from = this.timeFrom.toLocaleTimeString('nu', timeFormat);
    const to = this.timeTo.toLocaleTimeString('nu', timeFormat);

    return `TimeFrom ${from} TimeTo ${to}`;
  }

  get times() {
    const timeFormat = { hour: '2-digit', minute: '2-digit', hour12: false };
    const from = this.timeFrom.toLocaleTimeString('nu', timeFormat);
    const to = this.timeTo.toLocaleTimeString('nu', timeFormat);

    return { from, to };
  }
}
